import React, { useState } from 'react';
import styled from 'styled-components';
import { Table, Button, Icon } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import VideoModal from '../VideoModal'; // !!
import DeleteConfirmPopup from '../../Common/DeleteConfirmPopup';
import {
  DEFAULT_COLOR_OF_TRAINING_VIDEOS,
  DEFAULT_TYPE_OF_VIDEOS_DEFINITION_BY_ID,
} from '../../../constants/appConstants';
import {
  Wrapper,
  SpinnerContainer,
  Spinner,
} from '../../MenuGenerator/UserDetailBlock/StyleUserDetailBlock';

const Videos = ({
  videosList,
  setTrainingVideo,
  isVideoModalOpen,
  setIsVideoModalOpen,
  setActiveVideo,
  isLoadingDelete,
  isDeleteModal,
  openDeleteModal,
  closeDeleteModal,
  deleteVideos,
  isTrainingVideosLoading,
}) => {
  const [currentVideosName, setCurrentVideosName] = useState('');
  const [currentVideosId, setCurrentVideosId] = useState('');

  const handleEdit = React.useCallback(
    (video) => {
      setTrainingVideo(video);
    },
    [setTrainingVideo],
  );

  const showVideo = React.useCallback( // !!
    (video) => {
      setIsVideoModalOpen(true);
      setActiveVideo(video);
    },
    [setIsVideoModalOpen, setActiveVideo],
  
  );

  const onDeleteClick = React.useCallback(
    (productId) => {
      deleteVideos(productId);
    },
    [deleteVideos],
  );

  const openModal = React.useCallback(
    (name, id) => {
      setCurrentVideosName(name);
      setCurrentVideosId(id);
      openDeleteModal();
    },
    [setCurrentVideosName, openDeleteModal],
  );

  if (isTrainingVideosLoading) {
    return (
      <Wrapper>
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      </Wrapper>
    );
  }

  return (
    <React.Fragment>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Имя видео</Table.HeaderCell>
            <Table.HeaderCell>Тип видео</Table.HeaderCell>
            <Table.HeaderCell>Теги видео</Table.HeaderCell>
            <Table.HeaderCell>Управление</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {videosList &&
            videosList.map((video) => {
              return (
                <React.Fragment key={video.id}>
                  <Table.Row>
                    <Table.Cell>
                      <VideoNameButton // !!
                        style={{ background: DEFAULT_COLOR_OF_TRAINING_VIDEOS[video.video_type] }}
                        onClick={() => showVideo(video.url)}
                      >
                        {video.name} 
                        {/* // ПОКАЗАТЬ ВИДЕО */}
                      </VideoNameButton>   
                      
                    </Table.Cell>
                    <Table.Cell>
                      {DEFAULT_TYPE_OF_VIDEOS_DEFINITION_BY_ID[video.video_type]}
                    </Table.Cell>
                    <Table.Cell>
                      {!!video.tags &&
                        video.tags.map((tag) => {
                          return <TagsValue key={tag.tag_id}>{tag.name}</TagsValue>;
                        })}
                    </Table.Cell>
                    <Table.Cell>
                      <StyledLink to="/changeTrainingVideos" onClick={() => handleEdit(video)}>
                        <Button primary icon>
                          <Icon name="edit" />
                        </Button>
                      </StyledLink>
                      <Button negative onClick={() => openModal(video.name, video.id)} icon>
                        <Icon name="trash" />
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                </React.Fragment>
              );
            })}
        </Table.Body>
      </Table>

      <VideoModal isModalOpen={isVideoModalOpen} setIsModalOpen={setIsVideoModalOpen} /> 
      {/* // !! */}
      <DeleteConfirmPopup
        isLoadingDelete={isLoadingDelete}
        isOpen={isDeleteModal}
        title={currentVideosName}
        onDelete={() => onDeleteClick(currentVideosId)}
        onCancel={closeDeleteModal}
      />
    </React.Fragment>
  );
};

export default Videos;

const TagsValue = styled.p`
  margin-bottom: 0;
  text-align: center;
  background-color: #6acdf0;
  border: 1px solid white;
  border-radius: 5px;
`;

const activeClassName = 'active';
const StyledLink = styled(NavLink).attrs({
  activeClassName: activeClassName,
})``;

const VideoNameButton = styled.button`
  margin-bottom: 0;
  padding: 5px;
  text-align: center;
  border: 0px;
  width: 100%;
  border-radius: 4px;
  color: black;
  &:hover {
    color: white;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Videos/VideosList/Videos.jsx